import { useCallback, useEffect, useRef } from 'react';
import config from 'config';
import track from 'utils/dio/google-sso';

declare global {
  interface Window {
    google: any;
  }
}

interface IGoogleToken {
  credential: string;
}

interface IGoogleSignInButton {
  onSignup: (data: IGoogleToken) => void;
}

function GoogleSignInButton({ onSignup }: IGoogleSignInButton) {
  const signInBtn = useRef<HTMLDivElement>(null);

  const initializeSignInButton = useCallback(() => {
    window.google.accounts.id.initialize({
      client_id: config.gcpClientId,
      callback: (data: IGoogleToken) => {
        track.googleSignInCompleted();

        onSignup(data);
      },
    });
    window.google.accounts.id.renderButton(signInBtn.current, {
      locale: 'en',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      logo_alignment: 'center',
      shape: 'circle',
      width: 400,
      click_listener: () => track.googleSingInClick(),
    });
  }, [onSignup]);

  useEffect(() => {
    if (window.google) {
      initializeSignInButton();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.onload = initializeSignInButton;
      document.head.appendChild(script);
    }
  }, [initializeSignInButton]);

  return (
    <div className="mx-auto">
      <div ref={signInBtn} />
    </div>
  );
}

export default GoogleSignInButton;
